module.exports = __webpack_public_path__ + "2d9342dbf00bffbc2cad55c46317ef35.jpg";